
import PDFUtil from '../utils/pdf'
import OCCLogoBase64 from '../base64Files/occ-logo'

const fontSizeBylength = [
  { min: 0, max: 30, fontSize: 20 },
  { min: 31, max: 34, fontSize: 18 },
  { min: 35, max: 38, fontSize: 16 },
  { min: 39, max: 42, fontSize: 14 },
  { min: 43, max: 57, fontSize: 12 },
  { min: 57, max: 70, fontSize: 10 },
  { min: 70, max: 9999999, fontSize: 8 }
]

const getFontSizeBylength = (l) => fontSizeBylength.find((fsbl) => fsbl.min <= l && fsbl.max >= l).fontSize

export default {
  data () {
    return {
      coverLogoWidth: 280,
      coverLogoHeight: 280,
      coverLogoRatio: 1
    }
  },
  methods: {
    getDateString () {
      const today = new Date()
      const monthName = this.$t(`demographicReport.months.${[today.getMonth()]}`)
      return `${monthName} ${today.getDate()} de ${today.getFullYear()}`
    },
    $generateCover () {
      const pollNameFontSize = getFontSizeBylength((this.evaluation.name || '').length)
      const enterpriseFontSize = getFontSizeBylength((this.user.enterprise.name || '').length)
      let demographicsFontSize = getFontSizeBylength((this.demographicCoverItems || '').length)
      const evaluators = [
        this.$t('demographicReport.autoevaluations'),
        this.$t('demographicReport.leaders'),
        this.$t('demographicReport.pairs'),
        this.$t('demographicReport.dependents')
      ]
      const keys = ['auto', 'leaders', 'pairs', 'dependents']
      let rows = []
      let total = []
      let receivedTotal = 0
      let expectedTotal = 0
      let rateTotal = 0
      for (let i = 0; i < evaluators.length; i++) {
        let received = this.completedPolls[keys[i]]
        let expected = this.expectedPolls[keys[i]]
        let rate = null
        if (expected > 0) {
          rate = (received * 100) / expected
        }
        rows.push([
          { text: evaluators[i].toUpperCase(), margin: [0, 5, 0, 0], border: [true, true, true, true], bold: false, style: { color: '#6d7a7a' } },
          { text: expected === 0 ? '--' : expected, margin: [0, 5, 0, 0], border: [true, true, true, true], bold: false, style: { color: '#6d7a7a' } },
          { text: expected === 0 && received === 0 ? '--' : received, margin: [0, 5, 0, 0], border: [true, true, true, true], bold: false, style: { color: '#6d7a7a' } },
          { text: rate == null ? '--' : this.round(rate, 2) + '%', margin: [0, 5, 0, 0], border: [true, true, true, true], bold: false, style: { color: '#6d7a7a' } }
        ])
        receivedTotal += received
        expectedTotal += expected
      }
      if (expectedTotal > 0) {
        rateTotal = (receivedTotal * 100) / expectedTotal
      }
      total.push([
        { text: this.$t('demographicReport.total').toUpperCase(), margin: [0, 5, 0, 0], border: [true, true, true, true], bold: true, style: { color: '#6d7a7a' } },
        { text: expectedTotal === 0 ? '--' : expectedTotal, margin: [0, 5, 0, 0], border: [true, true, true, true], bold: true, style: { color: '#6d7a7a' } },
        { text: expectedTotal === 0 && receivedTotal === 0 ? '--' : receivedTotal, margin: [0, 5, 0, 0], border: [true, true, true, true], bold: true, style: { color: '#6d7a7a' } },
        { text: rateTotal === 0 ? '--' : this.round(rateTotal, 2) + '%', margin: [0, 5, 0, 0], border: [true, true, true, true], bold: true, style: { color: '#6d7a7a' } }
      ])
      if (this.enterpriseLogo) {
        let domEnterpriseLogo = document.getElementById('dynamicEnterpriseLogo')
        let w = domEnterpriseLogo.width
        let h = domEnterpriseLogo.height
        let rem = w % h
        let wRem = w / rem
        let hRem = h / rem
        let ratio = wRem / hRem
        if (ratio > 1) {
          this.coverLogoHeight = this.coverLogoWidth / ratio
          this.coverLogoRatio = ratio
        }
      }
      return [
        {
          columns: [
            // LEFT MAIN COLUMN
            {
              width: '40%',
              image: this.enterpriseLogo || OCCLogoBase64,
              fit: [this.coverLogoWidth, this.coverLogoHeight],
              aligment: 'center',
              margin: [0, 0, 0, 0],
              absolutePosition: { x: 35, y: ((595 - this.coverLogoHeight) / 2) }
            },
            // RIGHT MAIN COLUMN
            [
              {
                margin: [0, 25, 0, 0],
                columns: PDFUtil.generateCenteredText(this.$t('demographicReport.title').toUpperCase(), 28, true, false, false)
              },
              {
                margin: [0, 5, 0, 0],
                columns: PDFUtil.generateCenteredText(this.$t('demographicReport.subtitle').toUpperCase(), 24, false, false, false)
              },
              {
                margin: [0, 10, 0, 0],
                columns: PDFUtil.generateCenteredText(this.evaluation.name, pollNameFontSize, true)
              },
              {
                margin: [0, 10, 0, 0],
                columns: PDFUtil.generateCenteredText(this.user.enterprise.name, enterpriseFontSize, true)
              },
              {
                margin: [0, 0, 0, 0],
                columns: PDFUtil.generateCenteredText(this.getDateString(), 15, true)
              },
              {
                margin: [0, 10, 0, 0],
                columns: PDFUtil.generateCenteredText(this.demographicCoverItems, demographicsFontSize, false, false, false)
              },
              {
                margin: [0, 20, 0, 1],
                columns: PDFUtil.generateCenteredText(this.$t('demographicReport.poll_answers').toUpperCase(), 18, true)
              },
              {
                layout: {
                  defaultBorder: '',
                  fillColor: function (rowIndex) {
                    return (rowIndex === 0) ? '#BFBFBF' : null
                  },
                  border: [false, false, false, true]
                },
                table: {
                  widths: [100, 80, 80, 90],
                  headerRows: 1,
                  body: [
                    [
                      { text: '', margin: [0, 0, 0, 0], border: [true, true, true, true], bold: true, style: { color: '#fff' } },
                      { text: this.$t('demographicReport.requested').toUpperCase(), margin: [10, 10, 10, 0], border: [true, true, true, true], bold: true, style: { color: '#fff' } },
                      { text: this.$t('demographicReport.received').toUpperCase(), margin: [10, 10, 10, 0], border: [true, true, true, true], bold: true, style: { color: '#fff' } },
                      { text: this.$t('demographicReport.answers_rate').toUpperCase(), margin: [10, 3, 10, 0], border: [true, true, true, true], bold: true, style: { color: '#fff' } }
                    ],
                    // Body
                    ...rows,
                    ...total
                  ]
                },
                pageBreak: 'after',
                margin: [34, 0, 0, 0],
                border: [false, false, false, true],
                alignment: 'center',
                fontSize: 10
              }
            ]
          ]
        }
      ]
    }
  }
}
